import { Icon, Typography } from 'shared/ui'
import { type IColumn, CellWithoutContent } from 'shared/ui/TableNew'
import { type CustomFieldRow, FieldTypeConfig } from 'entities/CustomField'

import styles from './styles.module.scss'

type IColumnsProps = {
  getFieldTypeLabel: (type: string) => string
}

export const columns = ({ getFieldTypeLabel }: IColumnsProps): IColumn<CustomFieldRow>[] => [
  {
    field: 'name',
    name: 'Name',
    width: '280px',
    paddingHeader: '0 8px 0 14px',
    renderRowCell: (row) => {
      const config = FieldTypeConfig[row.fieldType]

      return (
        <div className={styles.name}>
          {config && (
            <Icon
              icon={config.icon}
              fontSize={16}
              padding={8}
              tertiary
              insideBox
              className={styles.iconBox}
            />
          )}
          <div className={styles.nameInfo}>
            <Typography
              ellipsis
              variant={'body-md-regular'}
              ariaLabel='customFieldName'
              tooltipProps={{ label: row.name }}
            >
              {row.name}
            </Typography>
            <Typography
              variant={'body-sm-regular'}
              color={'tertiary'}
              ariaLabel='customFieldType'
              className={styles.fieldType}
            >
              {getFieldTypeLabel(row.fieldType)}
            </Typography>
          </div>
        </div>
      )
    },
  },
  {
    field: 'default',
    name: '',
    width: '160px',
    renderHeaderCell: () => null,
    renderRowCell: (row) => {
      return row.isCustom ? (
        <CellWithoutContent />
      ) : (
        <Typography
          variant='body-md-regular'
          ariaLabel='customFieldDefault'
          className={styles.defaultLabel}
        >
          Default
        </Typography>
      )
    },
  },
  {
    field: 'visible',
    name: 'Show in conversations',
    width: '246px',
    renderRowCell: (row) => {
      return row.visible ? <Icon icon='check1' color='var(--light-blue-60)' /> : null
    },
  },
]
